import React from 'react';
import { useSelector } from 'react-redux';
import formatISO from 'date-fns/formatISO';
import { formatDate } from 'products/nomad_insurance/utils';
import LoadingOverlay from 'components/LoadingOverlay';
import { ReactComponent as CalendarDates } from 'products/nomad_insurance/assets/img/icons/calendar-dates.svg';
import { ReactComponent as Users } from 'products/nomad_insurance/assets/img/icons/users.svg';
import { ReactComponent as Addon } from 'products/nomad_insurance/assets/img/icons/addon.svg';
import SubscriptionCard from './components/SubscriptionCard';
import DiscountInfo from './components/DiscountInfo';
import {
  StyledPrice,
  SummaryHeading,
  Infos,
  InfoRow,
  ItemTexts,
  CoverageBg,
  MembersBg,
  AddonsBg,
  CostRow,
  Total,
  TotalPriceWrapper,
  TotalText,
  TotalPrice
} from './styled';
import VoucherInfo from './components/VoucherInfo';

const Price = () => {
  const { startDate, endDate, hasEndDate, numberOfDays, addons } = useSelector(
    // @ts-ignore state is not typed
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  // @ts-ignore state is not typed
  const { offer, isLoading } = useSelector(
    // @ts-ignore state is not typed
    (state) => state.nomadInsurance.application
  );

  const contractTotalPrice = offer?.totalPrice ?? 0;

  return (
    <StyledPrice>
      <LoadingOverlay isLoading={isLoading} variant="black" roundedCorners />
      <SummaryHeading>Summary</SummaryHeading>
      <Infos>
        <InfoRow>
          <CoverageBg>
            <CalendarDates />
          </CoverageBg>
          <ItemTexts>
            {hasEndDate ? (
              <>
                <div>Coverage period</div>
                <div>
                  {formatDate(startDate || formatISO(new Date()))} - {formatDate(endDate)}
                </div>
              </>
            ) : (
              <>
                <div>Coverage starts on</div>
                <div>{formatDate(startDate || formatISO(new Date()))}</div>
              </>
            )}
          </ItemTexts>
        </InfoRow>
        <InfoRow>
          <MembersBg>
            <Users />
          </MembersBg>
          <ItemTexts>
            <div>Member cost</div>
            {offer?.applicants?.map(
              (applicantOffer: {
                id: number;
                firstName: string;
                lastName: string;
                totalPrice: number;
              }) => {
                return (
                  <CostRow key={applicantOffer.id}>
                    {applicantOffer.firstName} {applicantOffer.lastName}
                    <span>${applicantOffer.totalPrice.toFixed(2)}</span>
                  </CostRow>
                );
              }
            )}
          </ItemTexts>
        </InfoRow>
        {addons?.length > 0 && (
          <InfoRow>
            <AddonsBg>
              <Addon />
            </AddonsBg>
            <ItemTexts>
              <div>Add-ons included</div>
              {addons.map((addon: { name: string }) => (
                <div key={addon.name}>{addon.name}</div>
              ))}
            </ItemTexts>
          </InfoRow>
        )}
      </Infos>
      <Total>
        <TotalPriceWrapper>
          <div>
            <TotalText>Total</TotalText>
            {hasEndDate ? <div>For {numberOfDays} days</div> : <div>Every 4 weeks</div>}
          </div>
          <TotalPrice>${contractTotalPrice.toFixed(2)}</TotalPrice>
        </TotalPriceWrapper>

        <SubscriptionCard />

        <DiscountInfo contractTotalPrice={contractTotalPrice} />
        <VoucherInfo />
      </Total>
    </StyledPrice>
  );
};

export default Price;
